<template>
    <PlanbordGridCell :header="header" class="comment-cell" info>
        <slot></slot>
    </PlanbordGridCell>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';

    @Component({
        components: {
            PlanbordGridCell,
        },
    })
    export default class PlanbordCommentCell extends Vue {
        @Prop({type: Boolean}) public header!: boolean;
    }
</script>

<style lang="scss" scoped>
    .comment-cell {
        display: var(--show-comment-cell, block);
    }
</style>
